import { assetsPath } from "../../utils";

const img1 = `${assetsPath('phuket-laguna-village-residences')}/images/concept/1.jpg`;
const img2 = `${assetsPath('phuket-laguna-village-residences')}/images/concept/2.jpg`;
const img3 = `${assetsPath('phuket-laguna-village-residences')}/images/concept/3.jpg`;
const img4 = `${assetsPath('phuket-laguna-village-residences')}/images/concept/4.jpg`;
const img5 = `${assetsPath('phuket-laguna-village-residences')}/images/concept/5.jpg`;
const img6 = `${assetsPath('phuket-laguna-village-residences')}/images/concept/6.jpg`;

const imageSlider = [
  { image: img1 },
  { image: img2 , backgroundPosition: '40% center' },
  { image: img3, backgroundPosition: 'left center' },
  { image: img4 },
  { image: img5, backgroundPosition: '60% center' },
  { image: img6, backgroundPosition: '10% center' }
];

const content = {
  en:
    "<p>Perfectly positioned around one of the tranquil lagoons which pepper this lush parkland adorning Phuket’s west coast, the 16 new private pool residences in the well-established Laguna Village Residences development are perfectly located and for sale within the heart of the upscale residential community set amidst palm tree-lined lagoons and landscaped gardens. </p><p>With an enviable address in a multi-award-winning destination resort, these 4-bedroom luxury villas in Laguna Village Residences offer residents a rare chance to be surrounded by five-star resorts and a myriad of leisure facilities all easily accessible via the Laguna inter-resort shuttle service.</p>",
  cn:
    "<p> 在普吉岛西海岸郁郁葱葱的静谧潟湖旁，成熟的Laguna Village Residences房地产开发项目新推出的十六套泳池住宅坐落在高档住宅小区的核心位置，棕榈树随处可见，景色宜人。 <br /> <br /> Laguna Village Residences 新推出的泳池住宅位于屡获殊荣的度假胜地的绝佳位置，周围是五星级度假村和一系列休闲设施，通过乐古浪往返于度假村之间的穿梭巴士可以轻松抵达。 </p>",
  ru:
    "<p> Идеально расположенные в одной из тихих лагун на обрамленном роскошной зеленью западном побережье Пхукета, 16 новых резиденций с бассейнами являются частью проекта застройки Laguna Village Residences. Отличное местоположение на территории жилого комплекса премиум-класса, раскинувшегося среди озер и тропических садов. <br /> <br /> Находящиеся в самом престижном районе острова, на территории удостоенного множества наград комплекса, резиденции Laguna Village Residences представляют собой редкий шанс жить в окружении пятизвездочных отелей, в доступности к морю и к самой стильной инфраструктуре острова, благодаря внутренней транспортной системе. </p>"
};

export default {
  imageSlider,
  content
};



// WEBPACK FOOTER //
// ./src/data/PhuketLagunaVillageResidences/concept.js